// extracted by mini-css-extract-plugin
module.exports = {"card":"project-module--card--3JJKb","cardText":"project-module--cardText--1qFd1","link":"project-module--link--1mK8a","image":"project-module--image--JR3Rw"};